module.exports = __webpack_public_path__ + "static/media/nurse.bdb94d91.webp";